import { NavLink } from 'react-router-dom';

const DANGER_PRODUCTS_RETURN_KEY = 'danger-products-return-state';

const CardDp = (props) => {
  const { data, currentPath, currentSearch = '', currentPage = 1 } = props;

  const handleClick = () => {
    try {
      sessionStorage.setItem(
        DANGER_PRODUCTS_RETURN_KEY,
        JSON.stringify({
          page: currentPage,
          productId: data.id,
          scrollY: window.scrollY,
          returnTo: `${currentPath}${currentSearch}`,
        }),
      );
    } catch (error) {
      // Ignore storage issues and continue navigation.
    }
  };

  return (
    <NavLink
      to={`/dangerproducts/detail/${data.id}`}
      state={{
        product: data,
        returnTo: `${currentPath}${currentSearch}`,
      }}
      className='wrapper__card-blog color__black d-inline-block w-100'
      style={{ transition: 'transform 0.2s, box-shadow 0.2s' }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.03)';
        e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)';
      }}
    >
      <img
        width='100'
        src={`${process.env.REACT_APP_FORMS_URl}/uploads/${data.doc}`}
        className='img'
        alt=''
      />
      <div className='desc'>
        <div className='d-flex align-items-center mb-2'>
          <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__gray-1'>
            <span className='b-700'>შეტყობინება :</span> #{data.id}
          </h5>
        </div>
        <div className='mb-2  font__size--16 text__20-1024 text-uppercase clamp__2 '>
          <span className='b-700'>სავაჭრო ნიშანი:</span> {data.trademark}
        </div>
        <div className='mb-2  font__size--16 text__20-1024 text-uppercase clamp__2 '>
          <span className='b-700 clamp__2 '>პროდუქტის დასახელება:</span>{' '}
          {data.product_title}
        </div>
        <div className='mb-2  font__size--14 text__18-1024 text-uppercase clamp__3 '>
          <span className='b-700'>რისკი:</span> {data.danger_description}
        </div>
        <p className='normal font__size--16 text__16-1024 clamp__3' />
        <div className='d-inline-block w-100 py-2'>
          <button
            href={`/dangerproducts/detail/${data.id}`}
            className='cardBtn w-100 semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'
          >
            ვრცლად
          </button>
        </div>
      </div>
    </NavLink>
  );
};

export default CardDp;
